import { Component } from '@angular/core';
import { PrimeNGButtonOpenItemViewActionComponent } from '@ntap/primeng';
import { map } from 'rxjs';

@Component({
  selector: 'app-edit-dok-datoteka-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class EditDokumentacijaDatotekaActionComponent extends PrimeNGButtonOpenItemViewActionComponent {
  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.itemProvider.item$.pipe(
      map((item: any) => {
        const residual = item['en~datoteka~rezidualni_podaci'] || false;
        return residual;
      })
    );
  }
}
